export var FeedType;
(function (FeedType) {
    FeedType["Awesome"] = "Awesome";
    FeedType["Happy"] = "Happy";
    FeedType["Acceptable"] = "Acceptable";
    FeedType["Sad"] = "Sad";
    FeedType["Bug"] = "Bug";
})(FeedType || (FeedType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/core/domain/common/feedType.ts
// module id = 887
// module chunks = 50